module.exports = __webpack_public_path__ + "img/orange-foot.97ea6425.png";